export function mapPaymentMethodToApiValue(paymentMethod?: string): string | undefined {
  switch (paymentMethod) {
    case 'DirectDebit':
      return 'direct_debit';
    case 'Invoice':
      return 'by_invoice';
    default:
      return paymentMethod;
  }
}

export const useFourWeeklyPayment = (year: number) => {
  return year < 2021;
};

export const PAYOUT_METHODS = {
  uitgekookt: 'uitgekookt',
  factuur: 'factuur',
  stichting: 'stichting'
};
